// import React, { createContext, useContext, useState, useEffect } from "react";
// import { themeStyles } from "./themeStyles";

// const ThemeContext = createContext();

// export function ThemeProvider({ children, defaultTheme = "light" }) {
//   const [theme, setTheme] = useState(defaultTheme);

//   const toggleTheme = () => {
//     setTheme((prev) => (prev === "light" ? "dark" : "light"));
//   };

//   const changeTheme = (newTheme) => {
//     if (newTheme !== theme) setTheme(newTheme);
//   };

//   // s для текущей темы
//   const s = themeStyles[theme];

//   return (
//     <ThemeContext.Provider value={{ theme, changeTheme, toggleTheme, s }}>
//       {children}
//     </ThemeContext.Provider>
//   );
// }

// export function useTheme() {
//   const ctx = useContext(ThemeContext);
//   if (!ctx) throw new Error("useTheme must be used within a ThemeProvider");
//   return ctx; // { theme, changeTheme, toggleTheme, s }
// }

import React, { createContext, useContext, useState, useEffect } from "react";
import { themeStyles } from "./themeStyles";

const ThemeContext = createContext();

export function ThemeProvider({ children, defaultTheme = "light" }) {
  // 1. При первом рендере читаем сохранённую тему или берём defaultTheme
  const [theme, setTheme] = useState(() => {
    // если в localStorage нет, вернётся null → используем defaultTheme
    return localStorage.getItem("theme") || defaultTheme;
  });

  // 2. При каждом изменении theme сохраняем в localStorage
  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  const changeTheme = (newTheme) => {
    if (newTheme !== theme) setTheme(newTheme);
  };

  // стили для текущей темы
  const s = themeStyles[theme];

  return (
    <ThemeContext.Provider value={{ theme, changeTheme, toggleTheme, s }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within a ThemeProvider");
  return ctx; // { theme, changeTheme, toggleTheme, s }
}
